import { Checkbox, CheckboxProps, FormControlLabel, FormControlLabelProps } from '@mui/material';
import { clsx } from 'clsx';

interface ICheckboxProps extends CheckboxProps {
    labelProps: Omit<FormControlLabelProps, 'control'>;
}

const FormControlCheckbox = ({ labelProps, ...checkboxProps }: ICheckboxProps) => (
    <FormControlLabel
        sx={{
            margin: 0,
            ...labelProps.sx,
        }}
        slotProps={{
            typography: {
                sx: {
                    lineHeight: '150%',
                    letterSpacing: -0.15,
                    color: 'neutral-800.main',
                },
            },
        }}
        {...labelProps}
        classes={{
            ...labelProps.classes,
            label: clsx('ml-1 font-medium text-sm', labelProps.classes?.label),
            asterisk: clsx('text-error-500', labelProps.classes?.asterisk),
        }}
        control={
            <Checkbox
                {...checkboxProps}
                classes={{
                    disabled: 'opacity-[.12]',
                    ...checkboxProps.classes,
                }}
            />
        }
    />
);

export { FormControlCheckbox };
